import { organizerApi } from '../api'
import { setEvents, setCurrent, setApplications, setLoading } from '../store/organizer/slice'


export const getEvents = (params) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const response = await organizerApi.getEvents(params)
    dispatch(setEvents(response.data.data))
  } catch (error) {
    console.log(error)
  } finally {
    dispatch(setLoading(false))
  }
}

export const getEvent = (eventId) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const response = await organizerApi.getEvent(eventId)
    dispatch(setCurrent(response.data.data))
  } catch (error) {
    console.log(error)
  } finally {
    dispatch(setLoading(false))
  }
}

export const getApplications = (eventId, params) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const response = await organizerApi.getApplications(eventId, params)
    dispatch(setApplications(response.data.data))
  } catch (error) {
    console.log(error)
  } finally {
    dispatch(setLoading(false))
  }
}

export const acceptApplication = (applicationId) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const response = await organizerApi.acceptApplication(applicationId)
    return response.data
  } catch (error) {
    console.log(error)
  } finally {
    dispatch(setLoading(false))
  }
}

export const rejectApplication = (applicationId, data) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const response = await organizerApi.rejectApplication(applicationId, data)
    return response.data
  } catch (error) {
    console.log(error)
  } finally {
    dispatch(setLoading(false))
  }
}

export const getEventResults = (eventId) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const response = await organizerApi.getEventResults(eventId)
    return response.data
  } catch (error) {
    console.log(error)
  } finally {
    dispatch(setLoading(false))
  }
}

export const createResult = (eventId, data) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const response = await organizerApi.createResult(eventId, data)
    return response.data
  } catch (error) {
    console.log(error)
  } finally {
    dispatch(setLoading(false))
  }
}

export const updateResult = (resultId, data) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const response = await organizerApi.updateResult(resultId, data)
    return response.data
  } catch (error) {
    console.log(error)
  } finally {
    dispatch(setLoading(false))
  }
}

export const deleteResult = (resultId) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    await organizerApi.deleteResult(resultId)
  } catch (error) {
    console.log(error)
  } finally {
    dispatch(setLoading(false))
  }
}
